<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/chile')"></nuxt-link> Producers</div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/chile/aconcagua/sena')">Sena</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/chile/aconcagua/vina-errazuriz')">Vina Errazuriz</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/chile/aconcagua/vina-von-sibenthal')">Vina Von Sibenthal</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/chile')"></nuxt-link> Producers</div>
                    <v-select
                            :items="items"
                            v-model="select"
                            label="Please choose"
                            single-line
                            item-text="report"
                            item-value="src"
                            return-object
                            class="show-mobile show-mobile-select"
                            v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Valle dell'Aconcagua</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        A lungo ritenuto troppo caldo per la produzione di vino, l'Aconcagua è ora una delle principali regioni del Cile. Ciò è in gran parte dovuto a Don Maximiano Errazuriz, un visionario pioniere del vino che ha piantato qui le prime talee di vite, con Cabernet Sauvignon, Merlot e Syrah che hanno trovato casa nel caratteristico microclima. L'Aconcagua ospita anche il maestoso, audace ed elegante Sena, la pluripremiata joint venture tra Robert Mondavi e Vina Errazuriz che si è classificata seconda nelle degustazioni alla cieca di Berlino del 2004, battendo molti Premier Cru francesi.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Aconcagua-Tal</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Aconcagua galt lange Zeit als zu heiß für die Weinproduktion und ist heute eine der führenden Regionen Chiles. Dies ist vor allem Don Maximiano Errazuriz zu verdanken, einem visionären Weinpionier, der hier die ersten Rebstöcke pflanzte, wobei Cabernet Sauvignon, Merlot und Syrah alle in dem besonderen Mikroklima ein Zuhause fanden. Aconcagua ist auch die Heimat des majestätischen, kühnen und eleganten Sena, dem preisgekrönten Joint Venture zwischen Robert Mondavi und Vina Errazuriz, das bei den Berliner Blindverkostungen 2004 den zweiten Platz belegte und viele französische Premiers Crus schlug.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vallée de l'Aconcagua</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Longtemps considérée comme trop chaude pour la production de vin, l'Aconcagua est aujourd'hui l'une des principales régions du Chili. C'est en grande partie grâce à Don Maximiano Errazuriz, un pionnier du vin visionnaire qui a planté ici les premières boutures de vigne, le cabernet sauvignon, le merlot et la syrah ayant tous trouvé leur place dans le microclimat distinctif. L'Aconcagua abrite également le majestueux, audacieux et élégant Sena, la coentreprise primée entre Robert Mondavi et Vina Errazuriz qui s'est classée deuxième lors des dégustations à l'aveugle de Berlin en 2004, battant de nombreux premiers crus français.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Aconcagua Valley</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Long thought to be too hot for wine production, Aconcagua is now one of Chile’s leading regions. This is largely thanks to Don Maximiano Errazuriz, a visionary wine pioneer planted the first vine cuttings here, with Cabernet Sauvignon, Merlot and Syrah all finding homes in the distinctive microclimate. Aconcagua is also home to the majestic, bold and elegant Sena, the award-winning joint venture between Robert Mondavi and Vina Errazuriz that came second in the Berlin blind tastings of 2004, beating many French Premiers Crus.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Aconcagua",
        data () {
            return {
                select: { report: 'Please choose', src: '#' },
                items: [
                    { report: 'Sena', src: '/wine-guide/chile/aconcagua/sena' },
                    { report: 'Vina Errazuriz', src: '/wine-guide/chile/aconcagua/vina-errazuriz' },
                    { report: 'Vina Von Sibenthal', src: '/wine-guide/chile/aconcagua/vina-von-sibenthal' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        },
        head: {
            title: 'Aconcagua Valley fine wine | Vindome Wine Guide',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Discover the rich flavors and diverse terroirs of the Aconcagua wine region in Chile. Known for producing premium red wines, including Cabernet Sauvignon and Carmenere, Aconcagua offers a unique winemaking experience unlike any other. Explore the stunning vineyards and taste the remarkable wines that embody the essence of Chile\'s winemaking tradition with a visit to the Aconcagua wine region.'
                }
            ],
            bodyAttrs: {
                class: 'wine-guide inner-page'
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover {
        border-color: #024E7B;
        background: #E5EDF2;
    }
</style>
